import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Styles from './Input.module.scss';
import classNames from 'classnames';

const TextInput = forwardRef(
  (
    {
      className,
      disabled,
      name,
      required,
      id,
      placeholder,
      label,
      icon: Icon,
      error,
      labelErrorClass,
      inputErrorClass,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={classNames(
          Styles.container,
          disabled && Styles.disabled,
          error && Styles.containerError,
          !label && !error && Styles.noLabel,
          className
        )}>
        {Icon && <Icon className={Styles.inputIcon} />}
        <input
          ref={ref}
          className={classNames(
            Styles.base,
            Styles.input,
            error && inputErrorClass,
            !!Icon && Styles.hasIcon
          )}
          id={id}
          name={name}
          placeholder={placeholder || label}
          required={required}
          disabled={disabled}
          {...props}
        />
        <label
          htmlFor={name}
          className={classNames(
            Styles.label,
            !!Icon && Styles.hasIcon,
            error && Styles.error,
            error && labelErrorClass
          )}>
          {error || label}
        </label>
      </div>
    );
  }
);

TextInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  inputErrorClass: PropTypes.string,
  labelErrorClass: PropTypes.string,
};

TextInput.defaultProps = {
  type: 'text',
};

export default TextInput;
